const { __ } = wp.i18n;
const { InspectorControls, InnerBlocks, MediaPlaceholder, TextAlignmentControl, MediaUpload, MediaUploadCheck } = wp.blockEditor;
const { useState, useEffect, Fragment, useRef } = wp.element;
const { useSelect } = wp.data;
import ReactDOMServer from 'react-dom/server';
const { ToggleControl, UnitControl, TextareaControl, PanelBody, __experimentalInputControl, __experimentalInputControlSuffixWrapper, CodeEditor, Card, CardMedia, CardFooter, __experimentalHeading, TextControl, Button, __experimentalToggleGroupControl, __experimentalToggleGroupControlOptionIcon, __experimentalBorderBoxControl, Icon, SelectControl, __experimentalToggleGroupControlOption, __experimentalDivider, BaseControl, Flex, FlexBlock, TabPanel } = wp.components;
import { useBlockProps } from '@wordpress/block-editor';
import DimensionsControl from '../../controls/dimensions/dimensions.js';
import ShortUniqueId from 'short-unique-id';
import { alignCenter, alignJustify, alignLeft, alignRight, justifyCenter, cancelCircleFilled } from '@wordpress/icons';
import { attributes } from '../attributes.js';
import { generateCSS, getCssCustomBlock, addAttributeResponsive, getCustomAttribute, replaceBackgroundImage } from '../functions.js';
import CustomAttributeControl from '../../controls/custom-attribute/custom-attribute.js';
import ColorSelector from '../../controls/color-select/color-select.js';
import BorderControl from '../../controls/border/border.js';
import TypographyControl from '../../controls/typography/typography.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FontAwesomeModal from '../../controls/fontawesome/fontawesome.js';
import DisplayControl from '../../controls/display/display.js';
import CssCustom from '../../controls/css-custom/css-custom.js';
import SizingControl from '../../controls/sizing/sizing.js';
import IconControl from '../../controls/icon/icon.js';
import { button } from '@wordpress/icons';
import DynamicDropdown from '../../controls/dynamic/dropdown/dropdown.js'
import './button.css';

wp.blocks.registerBlockType('softlite-io-integration/button', {
	apiVersion: 3,
	title: __('Button'),
	icon: button,
	category: 'softlite-io-integration',
	attributes: addAttributeResponsive(attributes),
	edit: (props) => {
        const { attributes, setAttributes } = props;
        const [css, setCss] = useState('');
        const generateID = new ShortUniqueId({ length: 8, dictionary: 'alphanum_lower' });
        const { id, custom_attributes } = attributes;
        const [content, setContent] = useState(attributes?.['button']?.content ? attributes?.['button']?.content : '');
        const [linkSettings, setLinkSettings] = useState({});
        const [icon, setIcon] = useState(attributes?.icon?.value ? attributes?.icon?.value : false);
        const [iconPosition, setIconPosition] = useState(attributes?.icon?.position ? attributes?.icon?.position : 'before');
        const [attributeCustom, setAttributeCustom] = useState({});
        const [htmlContent, setHtmlContent] = useState('');
        const openTab = attributes?.state?.openTab ?? 'setting';
        const openSettingSection = attributes?.state?.openSettingSection ?? 'settings';
        const openStyleSection = attributes?.state?.openStyleSection ?? 'layout';

        useEffect(() => {
            if (!id) {
                setAttributes({ id: generateID.rnd() });
            }
            const newCss = generateCSS(attributes, `softlite-block-${attributes.id}`);
            let cssCustomString = getCssCustomBlock(attributes);
            let iconCss = attributes?.icon?.size ? '' : '.softlite-block-button>svg{width:20px;height:20px}';
            setAttributes({ css: newCss + iconCss + '.softlite-block-button, .softlite-icon{display:inline-flex;align-items:center;}' });
            setCss(replaceBackgroundImage(cssCustomString + newCss + iconCss, softliteData.site_url));
            setIconPosition(attributes?.icon?.position ? attributes?.icon?.position : 'before');
            setAttributeCustom(getCustomAttribute(custom_attributes));
            setHtmlContent(buttonContent());
        }, [attributes]);

        const handleToggle = (name, type) => {
            setAttributes({state: {...attributes?.state, [type]: name === attributes?.state?.[type] ? '' : name}});
        };

        const handleChangeContent = (newText) => {
            setAttributes({ 'button': { ...attributes?.['button'], content: newText } });
            setContent(newText);
        }

        const handleChangeLink = (attribute, newValue) => {
            let rel = '';
            if (attribute === 'target' && newValue) {
                rel = attribute?.button?.rel ? `noopener ${attribute?.button?.rel}` : 'noopener';
            }
            if (attribute === 'rel') {
                rel = attribute?.button?.target === '_blank' ? `noopener ${newValue}` : 'noopener';
            }
            setAttributes({
                button: {
                    ...attributes?.['button'],
                    [attribute]: attribute === 'target' ? (newValue ? '_blank' : '') : newValue,
                }
            });

            const attributeValue = attribute === 'target' ? (newValue ? '_blank' : '') : newValue;

            if (attributeValue.trim() === '') {
                const newLinkSettings = { ...linkSettings };
                delete newLinkSettings[attribute];
                setLinkSettings(newLinkSettings);
            } else {
                setLinkSettings({ ...linkSettings, [attribute]: newValue });
            }
            if (rel) {
                setLinkSettings({ ...linkSettings, rel: rel });
            }
        }

        const handleSelectShortcode = (shortcode, oldValue, callable, parameter) => {
            const updatedContent = (oldValue ?? "") + shortcode;
            if(parameter){
                callable(parameter, updatedContent);
            }else{
                callable(updatedContent);
            }
        };

        const buttonContent = () => {
            if (iconPosition === 'after') {
                return `${icon ? `<span class='softlite-icon'>${ReactDOMServer.renderToStaticMarkup(<FontAwesomeIcon icon={icon} />)}</span>` : ''}${content}`;
            } else {
                return `${content}${icon ? `<span class='softlite-icon'>${ReactDOMServer.renderToStaticMarkup(<FontAwesomeIcon icon={icon} />)}</span>` : ''}`;
            }
        };

        const TagName = attributes?.['button']?.href ? 'a' : 'span';

        const advancedClassNames = attributes.className ? ' ' + attributes.className : '';

        const blockProps = useBlockProps({
            className: 'softlite-block-button' + (content === '' ? ' softlite-block-empty' : '') + advancedClassNames,
        });

        return (
            <>
                <InspectorControls>
                    <TabPanel
                        className="softlite-tab-panel"
                        activeClass="active-tab"
                        onSelect={(newTab) => setAttributes({state: {...attributes?.state, openTab: newTab}})}
                        initialTabName={openTab}
                        tabs={[
                            {
                                name: 'setting',
                                title: 'Setting',
                                className: 'softlite-tab-setting',
                            },
                            {
                                name: 'style',
                                title: 'Style',
                                className: 'softlite-tab-style',
                            },
                        ]}
                    >
                        {(tab) => <div>
                            {openTab == 'setting' && (
                                <>
                                    <PanelBody title={__('Settings')} opened={openSettingSection === 'settings'} onToggle={() => handleToggle('settings', 'openSettingSection')}>
                                        <__experimentalInputControl
                                            label="Text"
                                            onChange={(newText) => handleChangeContent(newText)}
                                            value={content}
                                            className="softlite-dynamic-inline"
                                            suffix={
                                                <__experimentalInputControlSuffixWrapper variant="icon" style={{ 'padding-right': '0px' }}>
                                                    <DynamicDropdown onSelect={(shortcode) => handleSelectShortcode(shortcode, content, handleChangeContent, false)} />
                                                </__experimentalInputControlSuffixWrapper>}
                                        />
                                        <__experimentalInputControl
                                            label="Link"
                                            onChange={(newValue) => handleChangeLink('href', newValue)}
                                            value={attributes?.['button']?.href}
                                            className="softlite-dynamic-inline"
                                            suffix={
                                                <__experimentalInputControlSuffixWrapper variant="icon" style={{ 'padding-right': '0px' }}>
                                                    <DynamicDropdown onSelect={(shortcode) => handleSelectShortcode(shortcode, attributes?.['button']?.href, handleChangeLink, 'href')} />
                                                </__experimentalInputControlSuffixWrapper>}
                                        />
                                        <__experimentalInputControl
                                            label="Rel"
                                            onChange={(newValue) => handleChangeLink('rel', newValue)}
                                            value={attributes?.['button']?.rel}
                                            className="softlite-dynamic-inline"
                                            suffix={
                                                <__experimentalInputControlSuffixWrapper variant="icon" style={{ 'padding-right': '0px' }}>
                                                    <DynamicDropdown onSelect={(shortcode) => handleSelectShortcode(shortcode, attributes?.['button']?.rel, handleChangeLink, 'rel')} />
                                                </__experimentalInputControlSuffixWrapper>}
                                        />
                                        <__experimentalInputControl
                                            label="Aria-label"
                                            onChange={(newValue) => handleChangeLink('aria-label', newValue)}
                                            value={attributes?.['button']?.['aria-label']}
                                            className="softlite-dynamic-inline"
                                            suffix={
                                                <__experimentalInputControlSuffixWrapper variant="icon" style={{ 'padding-right': '0px' }}>
                                                    <DynamicDropdown onSelect={(shortcode) => handleSelectShortcode(shortcode, attributes?.['button']?.['aria-label'], handleChangeLink, 'aria-label')} />
                                                </__experimentalInputControlSuffixWrapper>}
                                        />
                                        <ToggleControl
                                            checked={attributes?.['button']?.['target'] === '' || !attributes?.['button']?.['target'] ? false : true}
                                            label="Open in new window"
                                            onChange={(newValue) => handleChangeLink('target', newValue)}
                                        />
                                    </PanelBody>
                                    <PanelBody title={__('Icon')} opened={openSettingSection === 'icon'} onToggle={() => handleToggle('icon', 'openSettingSection')}>
                                        <IconControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                            onChangeIconPosition={setIconPosition}
                                            onChangeIcon={setIcon}
                                            attributeName={'icon'}
                                        />
                                    </PanelBody>
                                </>
                            )}
                            {openTab == 'style' && (
                                <>
                                    <PanelBody title={__('Layout')} opened={openStyleSection === 'layout'} onToggle={() => handleToggle('layout', 'openStyleSection')} >
                                        <__experimentalHeading>SPACING</__experimentalHeading>
                                        <label>Padding</label>
                                        <DimensionsControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                            attributeName="padding"
                                        />
                                        <__experimentalDivider />
                                        <label>Padding</label>
                                        <DimensionsControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                            attributeName="margin"
                                        />
                                        <__experimentalDivider />
                                        <SizingControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                        />
                                    </PanelBody>
                                    <PanelBody title={__('Typography')} opened={openStyleSection === 'typography'} onToggle={() => handleToggle('typography', 'openStyleSection')}>
                                        <TypographyControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                        />
                                    </PanelBody>
                                    <PanelBody title={__('Background')} opened={openStyleSection === 'background'} onToggle={() => handleToggle('background', 'openStyleSection')}>
                                        <ColorSelector
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                            attributeName="background-color"
                                        />
                                    </PanelBody>
                                    <PanelBody title={__('Border')} opened={openStyleSection === 'border'} onToggle={() => handleToggle('border', 'openStyleSection')}>
                                        <BorderControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                        />
                                    </PanelBody>
                                    <PanelBody title={__('Attributes')} opened={openStyleSection === 'custom-attribute'} onToggle={() => handleToggle('custom-attribute', 'openStyleSection')}>
                                        <CustomAttributeControl
                                            items={custom_attributes}
                                            onChange={(newItems) => setAttributes({ custom_attributes: newItems })}
                                        />
                                    </PanelBody>
                                    <PanelBody title={__('Custom CSS')} opened={openStyleSection === 'custom-css'} onToggle={() => handleToggle('custom-css', 'openStyleSection')}>
                                        <label>Padding</label>
                                        <CssCustom
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                        />
                                    </PanelBody>
                                </>
                            )}
                        </div>}
                    </TabPanel>
                </InspectorControls>

                <TagName{...linkSettings} {...blockProps} id={`softlite-block-${attributes.id}`} {...attributeCustom} dangerouslySetInnerHTML={{ __html: htmlContent }} />

                {css && (
                    <style type='text/css'>{css + `.softlite-block-button{display:flex;align-items:center;}`}</style>
                )}
            </>
        );
    },
	save: (props) => {
		const { attributes } = props;
		const content = attributes?.['button']?.content ? attributes?.['button']?.content : '';
		const linkSettings = {};
        let attributeCustom = getCustomAttribute(attributes?.custom_attributes);

		if (attributes?.['button']?.href) {
			linkSettings['href'] = attributes?.['button']?.href;
		}
		if (attributes?.['button']?.target) {
			linkSettings['target'] = attributes?.['button']?.target;
            linkSettings['rel'] = attributes?.['button']?.rel && !attributes?.['button']?.rel.includes('noopener') ? `noopener ${attributes?.['button']?.rel}` : 'noopener';
		}
		if (attributes?.['button']?.['aria-label']) {
			linkSettings['aria-label'] = attributes?.['button']?.['aria-label'];
		}
		if (attributes?.['button']?.rel) {
            linkSettings['rel'] = attributes?.['button']?.target == '_blank' && !attributes?.['button']?.rel.includes('noopener') ? `noopener ${attributes?.['button']?.rel}` : attributes?.['button']?.rel;
		}

		const icon = attributes?.icon?.value ? attributes?.icon?.value : false;
		const iconPosition = attributes?.icon?.position ? attributes?.icon?.position : 'before';

		const buttonContent = () => {
			if (iconPosition === 'after') {
				return `${icon ? `<span class='softlite-icon'>${ReactDOMServer.renderToStaticMarkup(<FontAwesomeIcon icon={icon} />)}</span>` : ''}${content}`;
			} else {
				return `${content}${icon ? `<span class='softlite-icon'>${ReactDOMServer.renderToStaticMarkup(<FontAwesomeIcon icon={icon} />)}</span>` : ''}`;
			}
		};

		const htmlContent = buttonContent();

		const TagName = linkSettings['href'] ? 'a' : 'span';

		const advancedClassNames = attributes.className ? ' ' + attributes.className : '';
        const allClassNames = `softlite-block-button${advancedClassNames}`;

		return (
			<>
				<TagName{...linkSettings} className={allClassNames} id={`softlite-block-${attributes.id}`} {...attributeCustom} dangerouslySetInnerHTML={{ __html: htmlContent }} />
			</>
		)
	},
});